import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { map, tap, withLatestFrom, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as fromInvoice from './invoice.reducer';
import * as InvoiceActions from './invoice.actions';
import * as InvoiceSelectors from './invoice.selectors';
import { APIService } from '../../services/api/api.service';

@Injectable()
export class InvoiceEffects {

  constructor(
    private actions$: Actions,
    private apiService: APIService,
    private notification: NzNotificationService,
    private store: Store
  ) { }

  // loadInvoice$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(InvoiceActions.loadInvoice),
  //     withLatestFrom(this.store.select(InvoiceSelectors.getInvoiceState)),
  //     fetch({
  //       run: (action, state) => {
  //         const query = { customerId: action.customerId };
  //         if (action.loadType === 'older' && state.startingAfter) {
  //           Object.assign(query, { starting_after: state.startingAfter });
  //         } else if (action.loadType === 'newer' && state.endingBefore) {
  //           Object.assign(query, { ending_before: state.endingBefore });
  //         }

  //         return this.apiService.getInvoices(query).pipe(
  //           tap(invoice => {
  //             if (!invoice.length) {
  //               if (action.loadType === 'newer') {
  //                 this.notification.info('Info', 'You are all caught up!');
  //               } else {
  //                 this.notification.info('Info', 'There are no older invoices');
  //               }
  //             }
  //           }),
  //           map(invoice =>
  //             InvoiceActions.loadInvoiceSuccess({
  //               invoice,
  //               loadType: action.loadType
  //             })
  //           )
  //         );
  //       },

  //       onError: (action, error) => {
  //         console.error('Error', error);

  //         this.notification.error(
  //           'Error',
  //           'There was an error loading invoices.'
  //         );

  //         return InvoiceActions.loadInvoiceFailure({ error });
  //       }
  //     })
  //   )
  // );

  loadInvoiceFromEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InvoiceActions.loadInvoiceFromEmail),
      withLatestFrom(this.store.select(InvoiceSelectors.getInvoiceState)),
      switchMap(([action, state]) => {
        const query = { email: action.email } as any;
        if (action.loadType === 'older' && state.startingAfter) {
          Object.assign(query, { starting_after: state.startingAfter });
        }
        return this.apiService.getInvoices(query).pipe(
          tap(invoice => {
            if (!invoice.length) {
              if (action.loadType === 'newer') {
                this.notification.info('Info', 'You are all caught up!');
              } else {
                this.notification.info('Info', 'There are no older invoices');
              }
            }
          }),
          map(invoice =>
            InvoiceActions.loadInvoiceSuccess({ invoice, loadType: action.loadType })
          ),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'There was an error loading invoices.');
            return of(InvoiceActions.loadInvoiceFailure({ error }));
          })
        );
      })
    )
  );
}
